import React, { useState,useEffect } from 'react';
import axios from '../../services/Api'
import AresNavBar from '../Layout/NavBar/NavBar';
import SideBar from '../Layout/SideBar/SideBar';
import AllPlans from './AllPlans';

import './index.css'

function Plans() {
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    try {
      let response = await axios.get('/api/plans');
      setPlans(response.data);
    } catch (e) {
      console.log(e);
    }
  }

  return (
    <div className="Plans">
      <AresNavBar />
      <SideBar />
      <AllPlans plans={plans} />
    </div>
  );
}

export default Plans;